<template>
  <abbr :title="i18n.t('simple_form.required.text')">
    {{ i18n.t('simple_form.required.mark') }}
  </abbr>
</template>
